import { FormEvent } from "react"
import uploadAndSetUrl from "./setFileUrl"

export default (e:FormEvent<Element>,handleSubmit:(arg0:string)=>void)=>{
    e.preventDefault()
    const files = ((e.target as HTMLFormElement)[0] as any).files
    uploadAndSetUrl(files,handleSubmit)
}